import { render } from "./UiNumberSelect.vue?vue&type=template&id=fee45b16&scoped=true&ts=true"
import script from "./UiNumberSelect.vue?vue&type=script&lang=ts"
export * from "./UiNumberSelect.vue?vue&type=script&lang=ts"

import "./UiNumberSelect.vue?vue&type=style&index=0&id=fee45b16&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee45b16"]])

export default __exports__